import { render, staticRenderFns } from "./setting-applicator.vue?vue&type=template&id=61ddd218"
import script from "./setting-applicator.ts?vue&type=script&lang=ts&external"
export * from "./setting-applicator.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports